export default __webpack_public_path__ + "static/media/behance.187c6c69.svg";